import { render } from "./TablesContent.vue?vue&type=template&id=4d23f698&ts=true"
import script from "./TablesContent.vue?vue&type=script&lang=ts"
export * from "./TablesContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__